// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__jcLga","calendarButtons":"ClockData_calendarButtons__1cLE8"};